module.exports = __webpack_public_path__ + "img/4.5889dbe5.jpg";